<template>
    <div class="c-select" :class="{'c-select--small': small}">
        <slot></slot>
        <div class="c-select__arrow">
            <font-awesome-icon :icon="faAngleDown" class="h-4 w-4" />
        </div>
    </div>
</template>
<script>
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

export default {
    props: {
        small: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        faAngleDown() {
            return faAngleDown;
        },
    },
};
</script>
